import React, { useCallback, useState } from 'react';
import { styled } from 'styled-components';
import { INSIGHTS_PALETTE } from './GeneralManagement/palette.js';
const HighlightTooltipContent = (props) => {
    if (!(props.active ?? false) ||
        !props.payload ||
        props.payload.length === 0) {
        return null;
    }
    return (React.createElement(HighlightTooltipContentReportSection, null,
        React.createElement(HighlightTooltipContentReportSection2, null, props.labelFormatter
            ? props.labelFormatter(props.label, props.payload)
            : typeof props.label === 'string' ||
                typeof props.label === 'number' ||
                React.isValidElement(props.label)
                ? props.label
                : null),
        props.payload.map((entry, idx) => {
            const dataKey = String(entry.dataKey ?? entry.name ?? '');
            const highlighted = props.hoveredKey !== null && props.hoveredKey === dataKey;
            const dimmed = props.hoveredKey !== null && !highlighted;
            const color = entry.color ?? entry.stroke ?? entry.fill ?? INSIGHTS_PALETTE.text;
            let valueNode = entry.value;
            let nameNode = entry.name;
            if (props.formatter && entry.value !== undefined) {
                const formatted = props.formatter(entry.value, entry.name ?? '', entry, idx, props.payload);
                if (Array.isArray(formatted)) {
                    valueNode = formatted[0];
                    nameNode = formatted[1];
                }
                else {
                    valueNode = formatted;
                }
            }
            return (React.createElement(HighlightTooltipContentReportSection3, { key: `${dataKey}-${idx}`, $background: highlighted ? `${color}22` : 'transparent', $fontWeight: highlighted ? 600 : 400, $opacity: dimmed ? 0.5 : 1 },
                React.createElement(HighlightTooltipContentMetricText, { $color: highlighted ? color : INSIGHTS_PALETTE.text },
                    React.createElement(HighlightTooltipContentChartFrame, { $background: color }),
                    nameNode),
                React.createElement(HighlightTooltipContentMetricText2, null, valueNode)));
        })));
};
export const useHighlightTooltip = () => {
    const [hoveredKey, setHoveredKey] = useState(null);
    const barProps = useCallback((dataKey) => ({
        onMouseEnter: () => setHoveredKey(dataKey),
        onMouseLeave: () => setHoveredKey(null),
    }), []);
    return {
        tooltipProps: {
            content: React.createElement(HighlightTooltipContent, { hoveredKey: hoveredKey }),
        },
        barProps,
        seriesProps: barProps,
    };
};
const HighlightTooltipContentReportSection = styled.div({
    background: INSIGHTS_PALETTE.surface,
    border: `1px solid ${INSIGHTS_PALETTE.border}`,
    borderRadius: 4,
    padding: '8px 10px',
    boxShadow: '0 2px 8px rgba(15, 23, 42, 0.08)',
    fontSize: 12,
    color: INSIGHTS_PALETTE.text,
    minWidth: 160,
    maxWidth: 320,
});
const HighlightTooltipContentReportSection2 = styled.div({
    fontWeight: 600,
    marginBottom: 4,
    color: INSIGHTS_PALETTE.textMuted,
});
const HighlightTooltipContentReportSection3 = styled.div((props) => ({
    display: 'flex',
    justifyContent: 'space-between',
    gap: 16,
    padding: '3px 6px',
    margin: '0 -6px',
    borderRadius: 3,
    background: props.$background,
    fontWeight: props.$fontWeight,
    opacity: props.$opacity,
    transition: 'background 80ms ease, opacity 80ms ease',
}));
const HighlightTooltipContentMetricText = styled.span((props) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    minWidth: 0,
    overflowWrap: 'anywhere',
    color: props.$color,
}));
const HighlightTooltipContentChartFrame = styled.span((props) => ({
    width: 8,
    height: 8,
    borderRadius: 2,
    background: props.$background,
    display: 'inline-block',
    flexShrink: 0,
}));
const HighlightTooltipContentMetricText2 = styled.span({ flexShrink: 0 });
//# sourceMappingURL=HighlightTooltip.js.map